// Browser/CDN entry point with singleton instance and auto-initialization
import { Tracker } from './tracker';

// Create singleton instance
const pulsora = new Tracker();

// Auto-initialize if data-token is present on script tag
if (typeof window !== 'undefined' && typeof document !== 'undefined') {
  // Attach to window for global access
  (window as any).pulsora = pulsora;

  // Check for script tag with data attributes
  if (document.currentScript) {
    const script = document.currentScript as HTMLScriptElement;
    const token = script.getAttribute('data-token');
    const endpoint = script.getAttribute('data-endpoint');
    const debug = script.getAttribute('data-debug') === 'true';

    if (token) {
      pulsora.init({
        apiToken: token,
        endpoint: endpoint || undefined,
        debug,
      });
    }
  }
}

// Export for module systems (though typically used via window.pulsora)
export default pulsora;
